import React, { useState } from 'react';
import styled from 'styled-components';
import { Col, Input, Row, Empty } from 'antd';
import SubBanner from '../components/SubBanner';
import ContentContainer from '../components/ContentContainer';
import Section from '../components/Section';
import CardNews from '../components/CardNews';
import PaginatedList from '../components/PaginatedList';
import ENDPOINTS from '../constants/endpoints';

const { Search } = Input;

const StyledSection = styled(Section)`
  padding-top: 24px;
  padding-bottom: 24px;
`;

export default function Blog() {
    const [search, setSearch] = useState('');

    return (
        <>
            <SubBanner title={'Notícias'} />
            <StyledSection>
                <ContentContainer>
                    <Row gutter={[0, 24]}>
                        <Col xs={24} md={{ offset: 12, span: 12 }}>
                            <Search
                                placeholder="Pesquisar por notícias"
                                size="large"
                                allowClear
                                onSearch={(value) => setSearch(value)}
                            />
                        </Col>
                        <Col xs={24}>
                            <PaginatedList
                                request={{
                                    url: ENDPOINTS.NEWS_LIST_PUBLIC,
                                    params: { search },
                                    dependence: [search]
                                }}
                                showTotal={false}
                                emptyComponent={
                                    <Row justify="center">
                                        <Empty description="Sem notícias no momento" />
                                    </Row>
                                }
                            >
                                {(news) => (
                                    <Row gutter={[24, 24]} align="start">
                                        {news.map(({ title, created_at, preview, image, slug }) => (
                                            <Col xs={24} sm={12} lg={8} key={slug}>
                                                <CardNews
                                                    title={title}
                                                    created_at={created_at}
                                                    resume={preview}
                                                    slug={slug}
                                                    image={image}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </PaginatedList>
                        </Col>
                    </Row>
                </ContentContainer>
            </StyledSection>
        </>
    );
}